import { isNumberOnly } from '@common/utils';

export const checkValidCatalogProductId = (catalog_product_id: string) => {
  return isNumberOnly(catalog_product_id) && catalog_product_id !== '0';
};

export function modifyQueryParams(url: string, params: { [key: string]: string }): string {
  try {
    const parsedUrl = new URL(url);
    const searchParams = parsedUrl.searchParams;

    for (const key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        searchParams.set(key, params[key]);
      }
    }

    parsedUrl.search = searchParams.toString();
    const modifiedUrl = parsedUrl.toString();

    return modifiedUrl;
  } catch (err) {
    return url;
  }
}

export function getFileExtension(file?: string | null) {
  try {
    if (!file) {
      return;
    }

    return file.split('?')[0].split('.').pop();
  } catch (err) {
    console.error(err);
  }
}
